import { getATLContextDomain } from '@atlaskit/atlassian-context/get-atl-context-domain';
import { getATLContextUrl } from '@atlaskit/atlassian-context/get-atl-context-url';

import { isFedramp } from '../config';

export function getAtlassianContextUrl(domainKey: string): string {
	if (isFedramp()) {
		return getATLContextUrl(domainKey);
	} else {
		return `https://${domainKey}.atlassian.com`;
	}
}

export function getAtlassianContextDomain(domainKey: string): string {
	if (isFedramp()) {
		return getATLContextDomain(domainKey);
	} else {
		return `${domainKey}.atlassian.com`;
	}
}
